import { AbstractEntityMapper } from '@pf/shared-services';
import {
    PickCreate,
    PickDto,
    PickRead,
    PickSearchParams,
} from '../../entities/pick.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { PickMetadataMap } from './pick.mapping-profile';

@Injectable()
export class PickMapper extends AbstractEntityMapper<
    PickRead,
    PickCreate,
    PickDto,
    PickSearchParams
> {
    constructor() {
        super(PickDto, PlatformWmsMapper, PickMetadataMap.symbols);
    }
}
